import { render, staticRenderFns } from "./depament.vue?vue&type=template&id=0dd98b68&scoped=true&"
import script from "./depament.vue?vue&type=script&lang=js&"
export * from "./depament.vue?vue&type=script&lang=js&"
import style0 from "./depament.vue?vue&type=style&index=0&id=0dd98b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd98b68",
  null
  
)

export default component.exports